import { useTheme } from '@chakra-ui/react';
import { isDark } from '@chakra-ui/theme-tools';

/* Returns a boolean based on the color. If color is defined,
 * check whether it's dark or light, if not, use fallback. */
export const useIsDarkTheme = ({
  color,
  fallback,
}: {
  color: string | undefined;
  fallback?: boolean;
}) => {
  const theme = useTheme();
  if (color === 'transparent') return false;
  return color ? isDark(color)(theme) : !!fallback;
};
